<template>
  <div id="app" class="app" ref="ulScroll1" v-loading="loading"  element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <header class="app_header">
      <el-row class="app_row" :style="{ backgroundColor: bgColor }">
        <el-col :span="16">
          <p @click="$router.replace('/').catch(() => {});menu = false"></p>
        </el-col>
        <el-col :span="8">
          <p
            :class="activeShow == 1 ? 'active' : ''"
            @click="
              activeShow = 1;
              $router.replace('/').catch(() => {});
            "
          >
            首页
          </p>
          <p
            :class="activeShow == 2 ? 'active' : ''"
            @mouseenter="ProductShow = true"
            @mouseleave="ProductLeave()"
          >
            产品中心
          </p>
          <p :class="activeShow == 3 ? 'active' : ''">
            <el-dropdown @command="useClick">
              <span class="el-dropdown-link">
                行业应用<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="智慧园区">智慧园区</el-dropdown-item>
                <el-dropdown-item command="智慧楼宇">智慧楼宇</el-dropdown-item>
                <el-dropdown-item command="智慧医院">智慧医院</el-dropdown-item>
                <el-dropdown-item command="智慧高校">智慧高校</el-dropdown-item>
                <el-dropdown-item command="智慧工业">智慧工业</el-dropdown-item>
                <el-dropdown-item command="智慧机场">智慧机场</el-dropdown-item>
                <el-dropdown-item command="轨道交通">轨道交通</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </p>
          <p
            :class="activeShow == 4 ? 'active' : ''"
            @click="
              activeShow = 4;
              $router.replace('/case').catch(() => {});
            "
          >
            经典案例
          </p>
          <p
            :class="activeShow == 5 ? 'active' : ''"
            @click="
              activeShow = 5;
              $router.replace('/towe').catch(() => {});
            "
          >
            关于我们
          </p>
          <div
            v-if="ProductShow"
            @mouseenter="ProductAlterLeave"
            @mouseleave="ProductShow = false"
          >
            <div
              v-for="(item, index) in Product"
              :key="index"
              @click="ProductClick(item)"
            >
              <img :src="item.img" alt="" />
              <p>
                <span>{{ item.tit }}</span>
                <!-- <span>{{ item.msg }}</span> -->
                <span></span>
              </p>
            </div>
          </div>
          <i v-if="!menu" class="el-icon-s-operation" @click="menu = true"></i>
          <i v-else class="el-icon-close" @click="menu = false"></i>
        </el-col>
      </el-row>
    </header>
    <router-view />
    <el-backtop ref="back" target=".app" :visibility-height="200"></el-backtop>
    <div v-if="menu" class="menu">
      <p></p>
      <el-menu
        default-active="2"
        class="el-menu-vertical-demo"
        background-color="#000000e6"
        text-color="#fff"
        router="true"
        unique-opened="true"
        @select="menuSele"
      >
        <el-submenu index="1">
          <template slot="title">
            <span>产品中心</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/product/core">核心优势</el-menu-item>
            <el-menu-item index="/product/cost">应用价值</el-menu-item>
            <el-menu-item index="/product/agent">AI 智能体</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">
            <span>行业应用</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/use/park">智慧园区</el-menu-item>
            <el-menu-item index="/use/building">智慧楼宇</el-menu-item>
            <el-menu-item index="/use/hospital">智慧医院</el-menu-item>
            <el-menu-item index="/use/school">智慧高校</el-menu-item>
            <el-menu-item index="/use/project">智慧工业</el-menu-item>
            <el-menu-item index="/use/airport">智慧机场</el-menu-item>
            <el-menu-item index="/use/traffic">轨道交通</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item index="/case">
          <span slot="title">经典案例</span>
        </el-menu-item>
        <el-menu-item index="/towe">
          <span slot="title">关于我们</span>
        </el-menu-item>
      </el-menu>
      <div @click="menu = false">

      </div>
    </div>
  </div>
</template>
<script>
import ScaleBox from "vue2-scale-box";
export default {
  components: { ScaleBox },
  data() {
    return {
      loading:false,
      activeShow: 1,
      // 产品中心鼠标移入
      ProductShow: false,
      Product: [
        // {
        //   img: require("@/assets/image/_yjs_.png"),
        //   tit: "数字孪生智慧楼宇管理系统微孪2.0",
        //   msg: "智慧楼宇数字化转型升级",
        // },
        {
          img: require("@/assets/image/核心优势 4.png"),
          tit: "核心优势",
          msg: "物联网 数字孪生 智慧能源算法",
        },
        {
          img: require("@/assets/image/产品目标.png"),
          tit: "应用价值",
          msg: "智慧管理 安全 效率 用户体验 节能减排",
        },
        {
          img: require("@/assets/image/智能体.png"),
          tit: "AI智能体",
          msg: "智慧管理 安全 效率 用户体验 节能减排",
        },
      ],
      bgColor: "",
      height: "1080",
      menu: false,
    };
  },
  watch: {
    $route(to, from) {
      this.scrollBar();
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 300);
      // 当路由发生变化时触发的回调函数
      if (
        to.path == "/product/core" ||
        to.path == "/product/twin20" ||
        to.path == "/product/cost"
      ) {
        this.activeShow = 2;
      } else if (to.path == "/") {
        this.activeShow = 1;
      } else if (
        to.path == "/use/park" ||
        to.path == "/use/building" ||
        to.path == "/use/project" ||
        to.path == "/use/traffic" ||
        to.path == "/use/school" ||
        to.path == "/use/airport" ||
        to.path == "/use/hospital"
      ) {
        this.activeShow = 3;
      } else if (to.path == "/case") {
        this.activeShow = 4;
      } else if (to.path == "/towe") {
        this.activeShow = 5;
      }
    },
  },
  mounted() {
    // 向页面添加股东事件
    window.addEventListener("scroll", this.handleScroll, true);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollTop(), true);
  },
  methods: {
    scrollBar() {
      this.$refs.ulScroll1.scrollTop = 0;
    },
    //滚动头部变色
    handleScroll(e) {
      let scrollY = e.target.scrollTop;
      //tab定位
      if (scrollY > 25) {
        this.bgColor = "rgba(0,0,0,.85)";
        this.scr_state = true;
      } else {
        this.bgColor = "transparent";
        this.scr_state = false;
      }
    },

    // 产品中心移入
    ProductLeave() {
      console.log("移入");
      this.ProductTime = setTimeout(() => {
        this.ProductShow = false;
      }, 500);
    },
    // 产品中心弹窗移入
    ProductAlterLeave() {
      clearTimeout(this.ProductTime);
      this.ProductShow = true;
    },
    // 产品中心点击事件
    ProductClick(msg) {
      console.log(msg);
      if (msg.tit == "核心优势") {
        this.$router.replace("/product/core").catch(() => {});
      } else if (msg.tit == "数字孪生智慧楼宇管理系统微孪2.0") {
        this.$router.replace("/product/twin20").catch(() => {});
      } else if (msg.tit == "应用价值") {
        this.$router.replace("/product/cost").catch(() => {});
      }else if (msg.tit == "AI智能体") {
        this.$router.replace("/product/agent").catch(() => {});
      }
    },

    // 行业应用
    useClick(msg) {
      this.activeShow = 3;
      this.$router.replace({ name: `行业应用-${msg}` }).catch(() => {});
    },
    menuSele(msg){
      this.menu = false
    }
  },
  destroyed() {
    //离开这个界面之后，删除滚动事件，不然容易除bug
    clearTimeout(this.ProductTime);
  },
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
::v-deep .menu {
  position: fixed;
  left: 0;
  top: 0%;
  z-index: 99;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  color: #fff;
  overflow: hidden;
  z-index: 1000;
  border-top: 1px solid #ccc;
  display: flex;
  flex-direction: column;
  >p{
    height: 244px;
    background: #000;
  }

  .el-menu {
    width: 99.9vw;
    ul {
      li:nth-child(1) {
        ul {
          font-size: 66px !important;
          li {
            font-size: 66px !important;
            height: 260px;
            line-height: 260px;
          }
        }
      }
    }
  }
  .el-menu-item {
    font-size: 66px !important;
    height: 260px !important;
    line-height: 260px !important;
    span {
      font-size: 66px !important;
      display: inline-block;
    }
  }
  .el-submenu__title {
    font-size: 66px;
    height: 260px;
    line-height: 260px;

    .el-submenu__icon-arrow {
      font-size: 126px;
      text-align: left;
      top: 22%;
    }
  }
  >div{
    flex: 1;
  }
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #b1adad;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #ededed;
}
.app {
  height: 100vh;
  overflow: hidden;
}

#app {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  overflow-x: hidden;

  @media screen and (max-width: 2560px) {
    .app_header {
      position: fixed;
      width: 100%;
      left: 0;
      top: 0;
      color: #fff;
      z-index: 999;

      .el-row {
        padding: 0 0 0 28px;
        transition: background-color 0.5s ease;
        /* 过渡效果，0.5秒时间，缓和的速度 */
        cursor: pointer;

        .el-col-16 {
          display: flex;
          align-items: center;
          height: 65px;
          line-height: 65px;

          p {
            width: 350px;
            height: 56px;
            background-image: url("@/assets/image/Yundun(Beijing)technology co.LTD_.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
          }
        }

        .el-col-8 {
          display: flex;
          justify-content: space-around;
          position: relative;
          padding-right: 30px;
          box-sizing: border-box;

          > p {
            font-size: 16px;
            height: 65px;
            line-height: 65px;
            font-family: "PuHui-fat-four";
            width: 86px;
            text-align: center;

            > .el-dropdown {
              font-size: 16px;
              color: #fff;

              span {
                height: 100%;
                display: inline-block;
              }
            }

            > .el-dropdown:hover {
              color: #4cf3ff;
            }
          }

          > p:hover {
            border-bottom: 1px solid #4cf3ff;
            color: #4cf3ff;
          }

          .active {
            border-bottom: 1px solid #4cf3ff;
            color: #4cf3ff;
          }

          > div {
            position: absolute;
            top: 120%;
            left: 16%;
            background-color: #000;
            border-top-width: 0px;
            padding: 0 20px;
            box-sizing: border-box;

            > div {
              display: flex;
              align-items: center;
              margin: 20px 0;

              img {
                width: 32px;
                height: 32px;
                margin-right: 10px;
              }

              p {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                width: 100%;

                span:nth-child(1) {
                  font-size: 16px;
                }

                span:nth-child(2) {
                  font-size: 12px;
                  color: #6a6a6a;
                  margin-top: 3px;
                }
              }

              p:hover {
                color: #4cf3ff;

                span:nth-child(2) {
                  color: #4cf3ff;
                }
              }
            }

            > div::before {
              //这里就是小三角了
              content: "";
              display: block;
              position: absolute;
              left: 70px; //给小三角定位，更具实际需求调整
              top: -18px; //给小三角定位，更具实际需求调整
              border-width: 10px;
              border-style: dashed dashed solid dashed; //四个参数分别代表向下，左，上右的小三角(对应方向的小三角设置为solid，其他的为dashed。我这里演示向左的小三角，所以设置第二个）
              border-color: transparent transparent black transparent; //四个参数分别代表向下，左，上右的小三角。对应方向的小三角设置你想要的颜色（为了直观我这里设置黑色），其他的为transparent。我这里演示向左的小三角，所以设置第二个。
            }
          }
        }
      }
      i {
        display: none;
      }

      .el-row:hover {
        background-color: #000 !important;
      }
    }
  }
  @media screen and (max-width: 800px) {
    .app_header {
      position: fixed;
      width: 100%;
      left: 0;
      top: 0;
      color: #fff;
      z-index: 999999;

      .el-row {
        padding: 0 50px 0 100px;
        transition: background-color 0.5s ease;
        /* 过渡效果，0.5秒时间，缓和的速度 */
        cursor: pointer;

        .el-col-16 {
          display: flex;
          align-items: center;
          height: 250px;
          line-height: 250px;

          p {
            width: 130px;
            height: 151px;
            background-image: url("@/assets/logo.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
          }
        }

        .el-col-8 {
          height: 250px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          position: relative;
          box-sizing: border-box;

          > p {
            display: none;

            > .el-dropdown {
              font-size: 16px;
              color: #fff;

              span {
                height: 100%;
                display: inline-block;
              }
            }

            > .el-dropdown:hover {
              color: #4cf3ff;
            }
          }

          > p:hover {
            border-bottom: 1px solid #4cf3ff;
            color: #4cf3ff;
          }

          .active {
            border-bottom: 1px solid #4cf3ff;
            color: #4cf3ff;
          }

          > div {
            position: absolute;
            top: 120%;
            left: 0%;
            background-color: #000;
            border-top-width: 0px;
            padding: 0 20px;
            box-sizing: border-box;
            display: none;

            > div {
              display: flex;
              align-items: center;
              margin: 20px 0;

              img {
                width: 32px;
                height: 32px;
                margin-right: 10px;
              }

              p {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                width: 100%;

                span:nth-child(1) {
                  font-size: 16px;
                }

                span:nth-child(2) {
                  font-size: 12px;
                  color: #6a6a6a;
                  margin-top: 3px;
                }
              }

              p:hover {
                color: #4cf3ff;

                span:nth-child(2) {
                  color: #4cf3ff;
                }
              }
            }

            > div::before {
              //这里就是小三角了
              content: "";
              display: block;
              position: absolute;
              left: 140px; //给小三角定位，更具实际需求调整
              top: -18px; //给小三角定位，更具实际需求调整
              border-width: 10px;
              border-style: dashed dashed solid dashed; //四个参数分别代表向下，左，上右的小三角(对应方向的小三角设置为solid，其他的为dashed。我这里演示向左的小三角，所以设置第二个）
              border-color: transparent transparent black transparent; //四个参数分别代表向下，左，上右的小三角。对应方向的小三角设置你想要的颜色（为了直观我这里设置黑色），其他的为transparent。我这里演示向左的小三角，所以设置第二个。
            }
          }
          i {
            display: inline-block;
            font-size: 130px;
          }
        }
      }

      .el-row:hover {
        background-color: #000 !important;
      }
    }
  }
}

body > .el-dropdown-menu {
  background-color: #000 !important;
  border: 1px solid #000 !important;

  .el-dropdown-menu__item {
    white-space: nowrap;
    color: #fff;
    padding: 0 20px !important;
  }

  .el-dropdown-menu__item:hover {
    color: #4cf3ff !important;
    background: none !important;
  }

  .popper__arrow::after {
    border-color: #000 !important;
    border-top-width: 0px !important;
  }
}
</style>
